import { Modal } from "bootstrap";
import Sortable from "sortablejs";

var addElementToSurvey, container, resetSurveyElementForm, uncollapsedNodeIds;

container = function (li) {
  if (li.classList.contains("root")) {
    return li.closest(".survey");
  } else if (li.childElementCount === 1) {
    return li.closest(".survey-children");
  } else {
    return li;
  }
};

addElementToSurvey = function (surveyElementId, survey, parent) {
  document
    .getElementById("loading-overlay")
    .classList.remove("visually-hidden");

  const payload = {
    survey_node: {
      parent_id: parent.id.replace("node-", ""),
      survey_element_id: surveyElementId,
      uncollapsed: uncollapsedNodeIds().join(","),
    },
  };

  fetch("/survey_nodes", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then(function (data) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data.html, "text/html");
      const newSurvey = doc.getElementsByClassName("survey")[0];
      survey.innerHTML = newSurvey.innerHTML;
      sortSurvey();
    })
    .catch(function (error) {
      console.error("Error:", error);
      var errorText = JSON.parse(error.responseText).error;
      survey.querySelector("li.alert-danger").style.display = "block";
      survey
        .querySelector("li.alert-danger")
        .insertAdjacentHTML("afterbegin", errorText);
      parent.classList.add("highlight");
    })
    .finally(function () {
      document
        .getElementById("loading-overlay")
        .classList.add("visually-hidden");
    });
};

const deleteSurveyNode = (e) => {
  e.preventDefault();
  var li = e.target.closest("li");
  var nodeId = li.id.replace("node-", "");
  var parentContainer = container(li);

  if (confirm("Are you sure?")) {
    document
      .getElementById("loading-overlay")
      .classList.remove("visually-hidden");

    fetch("/survey_nodes/" + nodeId, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => response.json())
      .then(function (data) {
        parentContainer.classList.add("highlight");
        parentContainer.style.display = "none";
        parentContainer.remove();

        var parentNode = li.parentElement;
        if (parentNode && !parentNode.classList.contains("survey-root")) {
          var dropdown = parentNode.querySelector(".add-element");
          dropdown.innerHTML = data.html;
        }
      })
      .catch(function (error) {
        parentContainer.classList.add("highlight");
      })
      .finally(function () {
        document
          .getElementById("loading-overlay")
          .classList.add("visually-hidden");
      });
  } else {
    document.getElementById("loading-overlay").classList.add("visually-hidden");
  }
};

resetSurveyElementForm = function () {
  fetch("/survey_elements/new?survey_element%5Btype%5D=Question")
    .then((response) => response.text())
    .then(function (data) {
      document.getElementById("new-question-form-fields").innerHTML =
        new DOMParser()
          .parseFromString(data, "text/html")
          .getElementById("new-question-form-fields").innerHTML;
    });
};

uncollapsedNodeIds = function () {
  return Array.from(document.querySelectorAll("ul.survey-children.show")).map(
    function (ul) {
      return ul.id.replace("children-of-", "");
    }
  );
};

const sortSurvey = () => {
  document.querySelectorAll(".survey-children").forEach(function (el) {
    new Sortable(el, {
      handle: ".handle",
      draggable: "li:not(.ending)",
      onSort: function (evt) {
        var node = evt.item;
        var node_id = node.id.replace("node-", "");

        var formData = { new_position: evt.newIndex };
        fetch("/survey_nodes/" + node_id + "/reorder", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
              .content,
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then(function () {
            node.parentElement.classList.add("highlight");
            node.parentElement.addEventListener("animationend", function () {
              node.parentElement.classList.remove("highlight");
            });
          })
          .catch(function () {
            node.parentElement.classList.add("errorlight");
            node.parentElement.addEventListener("animationend", function () {
              node.parentElement.classList.remove("errorlight");
            });
          });
      },
    });
  });
};

const addNewSurvey = (e) => {
  e.preventDefault();
  var input = document.querySelector(
    "input#survey_node_survey_element_attributes_text"
  );
  fetch("/survey_nodes", {
    method: "POST",
    body: JSON.stringify({
      survey_node: {
        survey_element_attributes: {
          text: input.value,
          type: "Root",
        },
      },
    }),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
    },
  })
    .then((response) => response.json())
    .then(function (data) {
      input.value = "";
      document
        .querySelector(".surveys")
        .insertAdjacentHTML("afterbegin", data.html);
    });
};

document.addEventListener("DOMContentLoaded", function () {
  let newQuestionModal, newEndingModal;
  sortSurvey();
  const questionModalContainer = document.getElementById("new-question-modal");
  if (questionModalContainer) {
    newQuestionModal = new Modal(questionModalContainer);
  }
  const endingModalContainer = document.getElementById("new-ending-modal");
  if (endingModalContainer) {
    newEndingModal = new Modal(endingModalContainer);
  }

  document
    .querySelectorAll(".new-question-modal-trigger, .new-ending-modal-trigger")
    .forEach(function (el) {
      el.addEventListener("click", function (e) {
        console.log(el.classList);
        if (el.classList.contains("new-ending-modal-trigger")) {
          newEndingModal.show();
          var parent = el.closest(".survey-node");
          endingModalContainer.querySelector(".parent-survey-node-id").value =
            parent.id.replace("node-", "");
        } else {
          newQuestionModal.show();
          var parent = el.closest(".survey-node");
          questionModalContainer.querySelector(".parent-survey-node-id").value =
            parent.id.replace("node-", "");
        }
      });
    });

  const surveys = document.getElementById("surveys");
  if (typeof surveys !== "undefined" && surveys !== null) {
    surveys.addEventListener("click", function (e) {
      if (e.target.parentNode.classList.contains("delete")) {
        deleteSurveyNode(e);
      }
      if (e.target.classList.contains("dropdown-item")) {
        e.preventDefault();
        var survey = e.target.closest(".survey");
        var parent = e.target.closest(".survey-node");
        var surveyElementId = e.target.dataset.surveyElementId;
        addElementToSurvey(surveyElementId, survey, parent);
      }
    });
  }

  const newForm = document.querySelector(".surveys-index #new_survey_node");
  if (newForm) {
    newForm.addEventListener("submit", function (e) {
      if (e.target.id == "new_survey_node") addNewSurvey(e);
    });
  }

  document
    .querySelectorAll(".new-survey-element-modal form")
    .forEach(function (el) {
      el.addEventListener("submit", function (e) {
        e.preventDefault();
        var form = e.target;

        fetch(form.action + ".json", {
          method: "POST",
          body: new FormData(form),
        })
          .then((response) => response.json())
          .then(function (data) {
            console.log(form);
            console.log(
              "node-" + form.querySelector(".parent-survey-node-id").value
            );
            var parentSurveyNode = document.getElementById(
              "node-" + form.querySelector(".parent-survey-node-id").value
            );
            var survey = parentSurveyNode.closest(".survey");
            addElementToSurvey(data.id, survey, parentSurveyNode);
            resetSurveyElementForm();
            newQuestionModal.hide();
            newEndingModal.hide();
          })
          .catch(function (error) {
            console.error("Error:", error);
          });
      });
    });

  // document.querySelectorAll(".new-survey-element-modal").forEach(function (el) {
  //   el.addEventListener("show.bs.modal", function (event) {
  //     var modal = event.target;
  //     var trigger = event.relatedTarget;
  //     var parent = trigger.closest(".survey-node");
  //     modal.querySelector("#parent-survey-node-id").value = parent.id.replace(
  //       "node-",
  //       ""
  //     );
  //   });
  // });
});
